let i18nInstance = null;

function getTextBlocks() {
    return document.querySelectorAll('[data-t-text]');
}

function getHtmlBlocks() {
    return document.querySelectorAll('[data-t-html]');
}

function getAttrBlocks() {
    return document.querySelectorAll('[data-t-attr]');
}

function translateText() {
    getTextBlocks().forEach((node) => {
        const key = node.dataset.tText;
        node.textContent = i18nInstance.t(key);
    })
}

function translateAttribute() {
    getAttrBlocks().forEach((node) => {
        try {
            const data = JSON.parse(node.getAttribute('data-t-attr'));
            data.forEach((attrItem) => {
                node.setAttribute(attrItem.attr, i18nInstance.t(attrItem.key));
            });
        } catch (e) {
            console.log(e);
            console.log('errors while translating attribute');
        }
    })
}

function translateHtml() {
    getHtmlBlocks().forEach((node) => {
        const key = node.dataset.tHtml;
        node.innerHTML = i18nInstance.t(key);
    })
}

window.addEventListener('load', function () {
    if (typeof __IS_DEVELOPMENT__ !== 'undefined' && __IS_DEVELOPMENT__) {
        emitLanguageChange();
    }
});

export function setI18n(i18n) {
    i18nInstance = i18n;
}

export function getI18n(i18n) {
    return i18nInstance;
}

export function emitLanguageChange() {
    translateText();
    translateHtml();
    translateAttribute();
}